import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useTranslation } from "@/hooks/useTranslation";

type SetupIntroductionStepProps = {
  translationPrefix: string;
  translationParams?: Record<string, string>;
};

export const SetupIntroductionStep = ({
  translationPrefix,
  translationParams,
}: SetupIntroductionStepProps) => {
  const { nextStep } = useStepper();
  const { t } = useTranslation();

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t(`${translationPrefix}.title`)}
      </h1>
      <p
        className="text-md"
        dangerouslySetInnerHTML={{
          __html: t(`${translationPrefix}.description`, translationParams),
        }}
      />
      <Button onClick={nextStep}>{t(`${translationPrefix}.button`)}</Button>
    </div>
  );
};
